export default __webpack_public_path__ + "images/assets/fd85399892e0ee2ed28422983502aa6b.svg";